<template>
  <div>
    <form class="modal-form">
      <custom-input
        required
        inputType="text"
        placeholder="Название"
        labelText="Название"
        v-model="model.name"
        :errorMessage="model.validator['name']"
        :inputValue="model.name"
        name="name"
      />

      <custom-input
        required
        inputType="number"
        placeholder="Высота, м"
        labelText="Высота, м"
        v-model="model.H"
        :errorMessage="model.validator['H']"
        :inputValue="model.H"
        name="H"
      />

      <div class="input-wrapper">
        <custom-input
          required
          inputType="number"
          placeholder="Площадь, м2"
          labelText="Площадь, м2"
          v-model="model.S"
          :errorMessage="model.validator['S']"
          :inputValue="model.S"
          name="S"
          :disabled="Boolean(model.autoS)"
        />
        <custom-checkbox
          class="form-checkbox"
          :value="Boolean(model.autoS)"
          @input="handleCheckboxChange"
          labelText="Автоматический расчет"
        />
      </div>
    </form>

    <div class="modal-footer-buttons">
      <main-button type="button" @click="save()">
        <span v-if="newDiking.id">Сохранить</span><span v-else>Сохранить</span>
      </main-button>
      <main-button color="link" type="button" @click="$emit('onCancelClick')">Отмена</main-button>
    </div>
  </div>
</template>

<script>
import "vue-form-generator/dist/vfg.css";
import MainButton from "../../components/ui/MainButton.vue";
import CustomInput from "../../components/ui/Input.vue";
import CustomCheckbox from "../../components/ui/Checkbox.vue";
import { baseMethods } from "./pipelines/baseMethods";
export default {
  name: "DikingEdit",
  components: { MainButton, CustomInput, CustomCheckbox },
  props: {
    proj_id: [Number, String],
    newDiking: Object,
    substrate: Object,
    dikings: Array,
  },
  mixins: [baseMethods],
  watch: {
    "model.autoS"() {
      if (this.model.autoS == 1) {
        this.model.S = this.getDikinsS(this.newDiking.dots, this.substrate.k);
      }
    },
  },
  mounted() {
    if (this.newDiking) {
      Object.assign(this.model, this.newDiking);
      if (this.model.autoS == 1) {
        this.model.S = this.getDikinsS(this.newDiking.dots, this.substrate.k);
      }
    }
  },
  data() {
    return {
      model: {
        name: "Обвалование",
        S: 100,
        H: 1,
        autoS: 1,
        validator: {},
      },
    };
  },
  methods: {
    save() {
      if (!this.newDiking.diking_id) {
        this.$http
          .post("risk/dikings/diking-add?proj_id=" + this.proj_id, this.model)
          .then((response) => {
            this.dikings.unshift(response.data);
            this.$emit("hide");
            this.$emit("clearCalculations")
          })
          .catch((e) => {
            this.$set(this.model, "validator", {});
            this.$set(this.model, "validator", e.response.data);
          });
      } else {
        this.$http
          .post("risk/dikings/diking-update?id=" + this.newDiking.diking_id, this.model)
          .then((response) => {
            this.$set(this.dikings, this.newDiking.index, response.data);
            this.$emit("hide");
            this.$emit("clearCalculations")
          })
          .catch((e) => {
            this.$set(this.model, "validator", {});
            this.$set(this.model, "validator", e.response.data);
          });
      }
    },

    handleCheckboxChange() {
      this.model.autoS = this.model.autoS === 1 ? 0 : 1;
      if (this.model.autoS === 1) {
        this.model.S = this.getDikinsS(this.newDiking.dots, this.substrate.k);
      }
    },
  },
};
</script>

<style scoped>
.form-checkbox {
  margin-bottom: 16px;
}
</style>
